import React from 'react'

import clsx from 'clsx'

import Tag from 'components/Tag'
import { useEventContext } from 'context/EventContext'
import { ROUTE_NAMES } from 'routes'
import routeService from 'services/routes'

import { DEFAULT_TOPIC, SEE_ALL_TOPIC } from '../../constants'

import classes from './TopicChip.module.scss'

const noop = () => {}
/** @type {import("./types").default} */
const TopicChip = ({ topic, activeChip, fetchOnClick = noop, className, ...props }) => {
  const { sendEvent } = useEventContext()
  const textToRender = topic.linkedFrom ? `${topic.name} (${topic.linkedFrom.posts.total})` : topic.name
  const isEnabled = activeChip === topic.slug || topic.enabled
  const enabledVariant = (isEnabled && topic.variant) || 'teal'
  const path =
    topic.slug && topic.slug !== SEE_ALL_TOPIC.slug
      ? routeService.generatePath(ROUTE_NAMES.RESOURCES_TOPIC, { slug: topic.slug })
      : routeService.generatePath(ROUTE_NAMES.RESOURCES_TOPICS_INDEX)
  const engagementDestination = topic.slug === SEE_ALL_TOPIC.slug ? 'go-to_topics' : 'filter_topic'

  const handleClick = event => {
    if (topic.slug !== SEE_ALL_TOPIC.slug) event.preventDefault()
    sendEvent({
      engagementComponent: 'resources_topics',
      name: 'engagement_navigation',
      engagementDestination,
      engagementDetails: `chip_${topic.slug}`,
    })
    if (topic.slug !== SEE_ALL_TOPIC.slug) {
      event.preventDefault()
    }
    fetchOnClick(topic.slug.toLowerCase())
  }

  return (
    <Tag
      className={clsx('TopicChip', classes.root, isEnabled && classes[enabledVariant], className)}
      // SEO trick, show as link but handle action with onclick
      href={DEFAULT_TOPIC.slug !== topic.slug && path}
      onClick={handleClick}
      {...props}
    >
      {textToRender}
    </Tag>
  )
}

export default TopicChip
